import React from 'react';
import { Prompt } from 'react-router-dom';
import { Observe } from 'rewire-core';
import { FormView } from 'rewire-ui';
import Divider from '@material-ui/core/Divider';
import { Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditTimecardView from '../timecard/edit/EditTimecardView';
import InfoPanelShiftNavigation from './InfoPanelShiftNavigation';
import InfoPanelMessagesView from './InfoPanelMessagesView';
import infoPanelShiftViewModel from './InfoPanelShiftViewModel';
import infoPanelShiftDetailsViewModel from './InfoPanelShiftDetailsViewModel';
import { makeStyles } from '../utility/styles';
import OptionsActionMenu from '../ui/OptionsActionMenu';
import scheduleModel from './ScheduleModel';

const useInfoPanelShiftDetailsStyles = makeStyles((_theme: Theme) => ({
  innerContentContainer: {
    display: 'flex',
    marginBottom: '10px',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  form: {
    flex: '1',
  },
  formField: {
    flex: '0 0 45%',
  },
  templateAndFilterContainer: {
    margin: '8px 0 0 0',
    display: 'flex',
  },
  templateContainer: {
    display: 'inline-flex',
    marginBottom: '8px',
    flex: '0 0 45%',
  },
  shiftNavigator: {
    display: 'inline-flex',
    marginBottom: '8px',
    '& > :not(button)': {
      paddingRight: 8,
    },
    alignItems: 'center',
    '& > button': {
      minWidth: 32,
    },
  },
  shiftContentsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  messages: {
    marginBottom: '5px',
  },
}));

const ShiftNavigator = () => {
  const classes = useInfoPanelShiftDetailsStyles();
  const moreItems = [
    {
      name: 'removeShift',
      disabled: () => !infoPanelShiftDetailsViewModel.canRemoveInnerShift(),
      title: 'Remove Shift',
      icon: DeleteIcon,
      onClick: infoPanelShiftDetailsViewModel.removeInnerShift,
      closeOnClick: true,
    },
  ];

  return (
    <div className={classes.shiftNavigator}>
      <Observe>
        {() => (
          <>
            <InfoPanelShiftNavigation title={infoPanelShiftDetailsViewModel.isNewInnerShift ? 'Add New Shift' : 'Edit Shift'} />
            {scheduleModel.viewMode === 'Job' && infoPanelShiftViewModel.state.isMultiShiftSelection === false && (
              <>
                <div style={{ flex: 1 }} />
                <Button
                  variant="contained"
                  disabled={!infoPanelShiftViewModel.canCreateInnerShift()}
                  color="primary"
                  onClick={() => infoPanelShiftViewModel.createInnerShift()}
                >
                  Add Shift
                </Button>
                {moreItems && moreItems.length > 0 ? (
                  <OptionsActionMenu title="More Options" tooltip="More Options" style={{ margin: 0 }} items={moreItems} />
                ) : null}
              </>
            )}
          </>
        )}
      </Observe>
    </div>
  );
};

export default () => {
  const classes = useInfoPanelShiftDetailsStyles();

  return (
    <Observe
      render={() => {
        return (
          <>
            <Observe
              render={() => {
                return (
                  <Prompt
                    when={infoPanelShiftDetailsViewModel.canSave()}
                    message={(_location) =>
                      `There are unsaved changes for ${infoPanelShiftDetailsViewModel.employee?.name ?? 'selected shift'}.\nDo you wish to return and save your changes?`
                    }
                  />
                );
              }}
            />
            <Observe
              render={() => (
                <InfoPanelMessagesView
                  className={classes.messages}
                  messages={infoPanelShiftDetailsViewModel.messages}
                  viewOnly={infoPanelShiftDetailsViewModel.viewOnly}
                />
              )}
            />
            <ShiftNavigator />
            <div className={classes.innerContentContainer}>
              <infoPanelShiftDetailsViewModel.form.field.area.Editor className={classes.formField} />
              <infoPanelShiftDetailsViewModel.form.field.group.Editor className={classes.formField} />
            </div>
            <div className={classes.innerContentContainer}>
              {scheduleModel.viewMode === 'Job' ? (
                <infoPanelShiftDetailsViewModel.form.field.occupation.Editor className={classes.formField} />
              ) : (
                <infoPanelShiftDetailsViewModel.form.field.employee.Editor className={classes.formField} />
              )}
              <infoPanelShiftDetailsViewModel.form.field.date.Editor className={classes.formField} />
            </div>
            {scheduleModel.viewMode === 'Job' && (
              <div className={classes.innerContentContainer}>
                <FormView
                  className={classes.form}
                  form={infoPanelShiftDetailsViewModel.form}
                  onSubmit={infoPanelShiftDetailsViewModel.actionFn('save')}
                >
                  <div className={classes.templateAndFilterContainer}>
                    <div className={classes.templateContainer}>
                      <infoPanelShiftDetailsViewModel.form.field.template.Editor />
                    </div>
                  </div>
                </FormView>
              </div>
            )}
            <Divider />
            <Observe
              render={() => (
                <EditTimecardView model={infoPanelShiftDetailsViewModel.editShiftModel} showBreaks breakdownMode showUdfs />
              )}
            />
          </>
        );
      }}
    />
  );
};
